import React, { useEffect, useRef } from "react";
import Fonts from "../assets/Fonts";
import Colors from "../assets/Colors";
import classes from "./MobileFilter.module.css";
import { CancelIconBlack, saveIcon } from "../../constant/imagePath";
import { ReactSVG } from "react-svg";

export const MobileFilter = ({
  filters,
  state,
  setter,
  handleClick,
  handleClickClear,
  showCancelIcon,
  handleClickSaveFilter,
  isScroll = true,
}) => {
  const scrollRef = useRef(null)
  useEffect(() => {

    scrollRef.current !== undefined && scrollRef.current !== null && scrollRef.current?.scrollIntoView({ inline: 'start', behaviour: 'smooth', block: 'nearest' })

  }, [state])
  return (
    <>
      <ul className={[classes.mainUl, isScroll && classes.scrollX].join(" ")}>
        {filters?.map((item, i) => {
          return (
            <li
              ref={state == item ? scrollRef : null}
              style={{
                ...Fonts.p2,
                color:
                  state === item ? Colors.white : Colors.neutralShadesOfNero,
                backgroundColor:
                  state === item
                    ? Colors.neutralShadesOfNero
                    : Colors.neutralShadesOfWhiteSmoke,
              }}
              className={[classes.filterbox].join(" ")}
              key={i}
              onClick={(e) => {
                if (item !== "Specialties") {
                  setter(item);
                  handleClick && handleClick(e);
                }
              }}
            >
              {item}
            </li>
          );
        })}
        {showCancelIcon && (
          <>
            <li className={classes.extra}>
              <ReactSVG
                onClick={handleClickClear}
                className={classes.CancelIconBlack}
                src={CancelIconBlack}
              />
            </li>
            <li className={classes.extra}>
              <ReactSVG
                onClick={handleClickSaveFilter}
                className={`${classes.CancelIconBlack} ${classes.saveIcon}`}
                src={saveIcon}
              />
            </li>
          </>
        )}
      </ul>
    </>
  );
};
